import styled from 'styled-components';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const InfoIcon = styled(InfoOutlinedIcon)`
  &.MuiSvgIcon-root {
    width: 14px;
    height: 14px;
    margin-left: 3px;
  }
`;

export const EditorWrapper = styled.div`
  padding-bottom: 10px;
  max-height: 70vh;
  overflow: auto;

  .ck-content {
    min-height: 50vh;

    ol,
    ul {
      &,
      ol,
      ul {
        margin-left: 20px;
      }
    }
  }
`;

export const EditNoteCard = styled.div`
  padding: 6px 16px;
  background-color: ${(props) => props.theme.note.backgroundColor};
  border-radius: 8px;
  color: #000;
  box-shadow: none;

  .content {
    max-width: 100%;
    max-height: 72px;
    overflow: auto;

    ${(props) => props.theme.breakpoints.down('md')} {
      max-height: 144px;
    }
  }
`;

export const StockWrapper = styled.div`
  .analysis-button {
    padding: 4px;
  }

  .analysis-icon {
    width: 18px;
    height: 18px;

    &.news {
      width: 16px;
      height: 16px;
    }

    ${(props) => props.theme.breakpoints.down('md')} {
      width: 24px;
      height: 24px;

      &.news {
        width: 22px;
        height: 22px;
      }
    }
  }
`;

export const NotificationsSection = styled.div`
  .MuiPaper-root {
    margin-bottom: 10px;
    margin-left: 0 !important;
    padding: 0;
    box-shadow: none;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    overflow: hidden;
  }

  .MuiCard-root {
    margin-left: 0;
  }
`;
